// src/theme/AppThemeProvider.tsx
// Puente entre el DarkModeContext existente y el ThemeProvider de MUI.
// Selecciona el tema (claro/oscuro) segun el contexto y aplica CssBaseline.
import React, { useContext, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import { DarkModeContext } from '../context/darkModeContext';
import { getTheme } from './theme';
import { SnackbarUtilsConfigurator } from '../utils/toast';

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { darkMode } = useContext(DarkModeContext);
  const theme = useMemo(() => getTheme(darkMode ? 'dark' : 'light'), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={4000}
        preventDuplicate
      >
        <SnackbarUtilsConfigurator />
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default AppThemeProvider;
